import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';

import { CompletedVisitProgress } from 'src/dropInClinic/completedVisits/CompletedVisitProgress';
import { CompletedVisitTable } from 'src/dropInClinic/completedVisits/CompletedVisitsTable';
import { useActiveVisits } from 'src/dropInClinic/hooks/useActiveVisits';
import { useCompletedVisitStatistics } from 'src/dropInClinic/hooks/useCompletedVisitStatistics';
import { useCompletedVisits } from 'src/dropInClinic/hooks/useCompletedVisits';

export const CompletedVisits = () => {
  const { completedVisits, error: completedVisitsError } = useCompletedVisits();
  const { activeVisits, error: activeVisitsError } = useActiveVisits();
  const statisticItems = useCompletedVisitStatistics(completedVisits, activeVisits);

  if (completedVisitsError) {
    return <div>Error loading completed visits: {completedVisitsError.message}</div>;
  }

  if (activeVisitsError) {
    return <div>Error loading active visits: {activeVisitsError.message}</div>;
  }

  if (!completedVisits || !activeVisits) {
    return <div>Loading completed and active visits</div>;
  }

  return (
    <>
      <CompletedVisitProgress data={statisticItems} />
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>Completed Visits</AccordionSummary>
        <AccordionDetails>
          <CompletedVisitTable completedVisits={completedVisits} />
        </AccordionDetails>
      </Accordion>
    </>
  );
};
